// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xnxkvmcztjcuwryggdsz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhueGt2bWN6dGpjdXdyeWdnZHN6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY3ODAzMDYsImV4cCI6MjA3MjM1NjMwNn0.dZ5iuFmXnpuOWFp2b_XNBE9DzjKWKGUeUzne7UHUgTk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    },
    log_level: 'error'
  },
  global: {
    headers: {
      'x-client-info': 'supabase-js-web'
    }
  }
});